import Vue from 'vue';
import App from './App.vue';
import router from '@/router';
import store from '@/store';
import './registerServiceWorker';
import VueAxe from 'vue-axe';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faClock,
  faMapMarkerAlt,
  faLink,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fixIdScrolling } from '@/mixins/fixIdScrolling';
import { clearUrlHash } from '@/mixins/clearUrlHash';

library.add(faClock);
library.add(faMapMarkerAlt);
library.add(faLink);

Vue.component('font-awesome-icon', FontAwesomeIcon);

// Set dynamic meta data
import VueMeta from 'vue-meta';
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});

// Prevent scrolling when pop-up shows
import VScrollLock from 'v-scroll-lock';
Vue.use(VScrollLock);

Vue.config.productionTip = false;

// vue-axe for a11y console.warning
if (process.env.NODE_ENV === 'develop') {
  Vue.use(VueAxe, {
    config: {
      branding: {
        brand: 'temple_museum',
      },
      runOnly: {
        type: 'tag',
        values: ['wcag2a'],
      },
    },
  });
}

new Vue({
  mixins: [fixIdScrolling, clearUrlHash],
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
